import React from 'react'
import { BaseView } from '@/components/base'

interface EmptyKemCardProps {
  containerStyle?: React.CSSProperties
  kemCardImage?: string
}

export const EmptyKemCard: React.FC<EmptyKemCardProps> = ({
  containerStyle,
  kemCardImage = '/assets/purple-sprinkles-with-chip.png',
}) => {
  return (
    <BaseView
      data-component="empty-kem-card"
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        aspectRatio: '16/9', // Сохраняем пропорции карты
        minHeight: '180px',
        maxHeight: '220px',
        // borderRadius: '24px',
        overflow: 'hidden',
        ...containerStyle,
      }}
    >
      {/* Background Image - только картинка, никаких номеров */}
      <BaseView
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${kemCardImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </BaseView>
  )
}
